import { useEffect, useMemo } from 'react';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import { urls } from 'features/common/fetch/constants';
import { fetchAvailableMarketLeads } from 'features/views/marketPlace/actions';
import { LEAD_ALREADY_TAKEN } from 'features/views/marketPlace/constants';
import { getAvailableLeads } from 'features/views/marketPlace/selectors';

import Lead from './Lead';

export const MarketPlaceLeads = () => {
	const dispatch = useDispatch();
	const availableLeads = useSelector(getAvailableLeads);

	useEffect(() => {
		dispatch(fetchAvailableMarketLeads());
	}, [dispatch]);

	const ignoreErrorsForTakeLead = useIgnoreErrorsWhen({
		fetchStorePath: urls.takeLead,
		attributePath: ['metaData', 'parsedContent', 'code'],
		value: LEAD_ALREADY_TAKEN,
	});

	const noResults = useMemo(
		() => <Alert severity="info">{getLabelMessage('marketPlace:noAvailableLeadsToTake')}</Alert>,
		[],
	);

	return (
		<Stack spacing={2}>
			<ComponentLoader fetchStorePath={urls.competitionAvailableLeads}>
				<ComponentLoader fetchStorePath={urls.takeLead} ignoreErrors={ignoreErrorsForTakeLead}>
					{isNilOrEmpty(availableLeads) ? (
						noResults
					) : (
						<Paper
							sx={{ p: 3, borderRadius: 2, backgroundColor: (theme) => theme.palette.background[100] }}
						>
							<Grid container spacing={2}>
								{availableLeads.map((leadData) => (
									<Grid size={4}>
										<Lead lead={leadData} />
									</Grid>
								))}
							</Grid>
						</Paper>
					)}
				</ComponentLoader>
			</ComponentLoader>
		</Stack>
	);
};

export default MarketPlaceLeads;
